module.exports = __webpack_public_path__ + "static/img/23.63b3908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/23.jpg
// module id = KrsZ
// module chunks = 1